<template>
  <div class="product-carousel-wrapper no-article-gutter-mobile no-article-swipe" ref="carousel">
    <div class="product-carousel-horizontal-line no-mobile-article-gutter" v-if="products"></div>
    <div class="product-carousel">
        <a v-if="product" :href="`#product-${index}`" class="product-carousel-item" v-for="(product, index) in products">
          <div class="product-carousel-item-circle-border">
            <img v-image-orientation  v-lazy="image(product)"/>
          </div>
          <span class="product-carousel-item-title">{{product.product.title}}</span>
        </a>
    </div>
  </div>
</template>

<script>
  import get from 'lodash/get'
  import ImageOrientation from 'directives/imageOrientation'
  import { supportPassive } from 'mixins/utilities'

  export default {
    name: 'comparison-product-carousel',
    props: ['products'],
    directives: {
      ImageOrientation,
    },
    data() {
      return {
        startX: 0,
        originalScrollX: 0,
      }
    },
    mounted() {
      const passive = supportPassive() ? { passive: true } : false
      this.$refs.carousel.addEventListener('touchstart', (e) => {
        this.startX = e.touches[0].clientX
        this.originalScrollX = this.$refs.carousel.scrollLeft
      }, passive)
      this.$refs.carousel.addEventListener('touchmove', (e) => {
        const targetX = this.originalScrollX + (this.startX - e.touches[0].clientX)
        if (targetX < 0 || targetX > this.$refs.carousel.scrollWidth - this.$refs.carousel.offsetWidth) {
          if (targetX < 0) {
            this.$refs.carousel.scrollLeft = 0
          } else {
            this.$refs.carousel.scrollLeft = this.$refs.carousel.scrollWidth - this.$refs.carousel.offsetWidth
          }
          this.startX = e.touches[0].clientX
          this.originalScrollX = this.$refs.carousel.scrollLeft
          return
        }
        this.$refs.carousel.scrollLeft = targetX
      }, passive)
    },
    methods: {
      image(product) {
        const originalProductImage = get(product, 'product.images[0].style_650w', '')
        const comparisonProductImage = get(product, 'images[0].style_650w', '')
        return comparisonProductImage !== '' ? comparisonProductImage : originalProductImage
      },
    },
  }
</script>

<style scoped lang="scss">
  $product-carousel-padding: rem-calc(16);
  $product-carousel-item-border-color: $waterspout;
  $product-carousel-item-dimension: rem-calc(102); //dimension also relates to horizonal-line and the circle-border
  $product-carousel-horizontal-line-position: $product-carousel-item-dimension / 2; //to be positioned at the center of the circle vertically

  .product-carousel-wrapper {
    overflow: hidden;
    position: relative;
    @include hide-scrollbar();
    .product-carousel-horizontal-line {
      z-index: 2;
      height: 2px;
      width: 100%;
      background-color: $product-carousel-item-border-color;
      position: absolute;
      top: $product-carousel-horizontal-line-position;
    }

    .product-carousel {
      z-index: 3;
      display: flex;
      position: relative;
      padding: 0;
      @include respond-to('desktop') {
        padding-bottom: rem-calc(33);
      }
    }

    .product-carousel-item {
      display: inline-block;
      margin-right: rem-calc(12);
      width: $product-carousel-item-dimension;

      .product-carousel-item-circle-border {
        height: $product-carousel-item-dimension;
        width: $product-carousel-item-dimension;
        background-color: $white;
        border: 1px solid $product-carousel-item-border-color;
        border-radius: 50%;
        overflow: hidden;
        padding-top: rem-calc(16);
        position: relative;
        img{
          &.landscape, &.square{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            max-width: rem-calc(145);
          }
        }
      }

      .product-carousel-item-title {
        font-size: rem-calc(12);
        line-height: rem-calc(13);
        color: $rose;
        font-weight: bold;
        display: block;
        text-align: center;
        margin-top: rem-calc(12);
      }

      img {
        max-width: $product-carousel-item-dimension - 2rem; //max-width of image to be less then the dimension
        max-height: rem-calc(145);
        width: auto;
        display: block;
        margin: 0 auto;
      }

      &:first-child {
        margin-left: rem-calc(12);
      }
      &:after {
        display: block;
        content: '';
        height: 2px;
        width: $product-carousel-item-dimension + rem-calc(24);
        margin-left: rem-calc(-12);
        background-color: $product-carousel-item-border-color;
        position: absolute;
        top: $product-carousel-horizontal-line-position;
        z-index: -1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ComparisonProductCarousel.vue?73f62c2a